import { authNiaRegisterQuery, useAxiosInstance } from '@gov-nx/api';
import { logger } from '@gov-nx/api';
import type { ApiCallback } from '@gov-nx/core/hooks';
import { useAuthStore } from '@gov-nx/store';
import { delay } from '@gov-nx/utils/common';

export const useAuthNiaRegisterQuery = () => {
	const setAccessToken = useAuthStore('setAccessToken');
	const { axiosInstance } = useAxiosInstance();

	const fetch = async (
		accessToken: string,
		{ reject, resolve }: ApiCallback<undefined, Error>
	): Promise<void> => {
		try {
			logger('before await authNiaRegisterQuery accessToken', [accessToken]);
			const instance = await authNiaRegisterQuery(
				axiosInstance,
				accessToken as string
			);
			logger('before setAccessToken(instance.access_token)', [
				instance.access_token,
			]);
			setAccessToken(instance.access_token);
			await delay(200);
			logger('before resolve && resolve()', []);
			resolve && resolve();
		} catch (e) {
			logger('before reject && reject(e as Error)', [(e as Error).toString()]);
			reject && reject(e as Error);
		}
	};

	return { fetch };
};
